import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SECTION_IDS } from "@/lib/navigation";

export const Transparency = () => {
  const { t } = useTranslation();
  const faq = t("transparency.faq", { returnObjects: true }) || [];
  const checklist = t("transparency.checklist", { returnObjects: true }) || [];

  return (
    <section
      id={SECTION_IDS.transparency}
      className="border-b border-border bg-background"
      data-testid="home-transparency"
    >
      <div className="container-page py-16 sm:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-6">
            <p className="eyebrow">{t("transparency.eyebrow")}</p>
            <h2 className="mt-4 text-2xl font-semibold leading-tight tracking-tight text-foreground sm:text-[34px]">
              {t("transparency.title")}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-[hsl(var(--ink-2))] sm:text-base">
              {t("transparency.p1")}
            </p>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground sm:text-base">
              {t("transparency.p2")}
            </p>

            <div className="mt-7 rounded-xl border border-border bg-[hsl(var(--surface-2))] p-5">
              <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground">
                <ShieldCheck className="h-4 w-4 text-[hsl(var(--terracotta))]" />
                {t("transparency.checklist_title")}
              </h3>
              <ul className="mt-3 space-y-2">
                {checklist.map((item) => (
                  <li
                    key={item}
                    className="border-l-2 border-border pl-3 text-sm leading-relaxed text-muted-foreground"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="rounded-xl border border-border bg-card p-2 sm:p-4">
              <h3 className="px-3 pt-3 font-display text-base font-semibold text-foreground">
                {t("transparency.faq_title")}
              </h3>
              <Accordion
                type="single"
                collapsible
                defaultValue="item-0"
                className="mt-2 px-1"
              >
                {faq.map((row, index) => (
                  <AccordionItem
                    key={row.q}
                    value={`item-${index}`}
                    data-testid={`transparency-faq-${index}`}
                  >
                    <AccordionTrigger className="px-2 text-left text-sm font-medium">
                      {row.q}
                    </AccordionTrigger>
                    <AccordionContent className="px-2 text-sm leading-relaxed text-muted-foreground">
                      {row.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Transparency;
